<template>
  <div
    class="sound-wave"
    @click="toggleSound()"
    @mouseenter="cursorToScroll()"
    @mouseleave="cursorToClose()"
  >
    <span class="sound-wave__line"></span>
    <span class="sound-wave__line"></span>
    <span class="sound-wave__line"></span>
  </div>
</template>

<script>
import { TweenMax, Linear } from 'gsap/TweenMax';

import Sound from '@/scripts/Sound';
import { randomInteger } from '@/scripts/utils';

export default {
  name: 'SoundWave',

  data() {
    return {
      sound: null,
      tl: null,
    };
  },

  mounted() {
    this.sound = Sound;
    this.spans = this.$el.querySelectorAll('.sound-wave__line');
    TweenMax.set(this.spans, { scaleY: 0.3 });
  },

  methods: {
    toggleSound() {
      this.sound.toggleAudio();

      if (!this.sound.state.isPlaying) {
        this.spans.forEach(span => TweenMax.killTweensOf(span));
        TweenMax.to(this.spans, 0.3, { scaleY: 0.3 });
      } else {
        this.animateWaves();
      }
    },

    animateWaves() {
      this.spans.forEach((span) => {
        TweenMax.killTweensOf(span);
        this.animateSpan(span);
      });
    },

    animateSpan(el) {
      const tween = TweenMax.to(el, 0.5, {
        ease: Linear.easeNone,
        scaleY: randomInteger(30, 100) / 100,
        onComplete: () => {
          this.animateSpan(el);
        },
      });

      return tween;
    },

    cursorToScroll() {
      this.$eventHub.$emit('soundInteraction');
      this.$eventHub.$emit('cursorToZoom');
    },

    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sound-wave {
  @include mq($and: $is-touch-device) {
    @include visually-hidden;
  }

  position: fixed;
  bottom: 60px;
  left: 23px;
  width: 22px;
  height: 35px;
  padding: 15px;
  box-sizing: content-box;
  opacity: 0;

  z-index: 50 !important;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  cursor: pointer;

  span {
    display: inline-block;
    width: 2px;
    height: 100%;

    background-color: $color-secondary;

    transform-origin: 0% 100%;
  }
}
</style>
